import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import classnames from 'classnames';

import Styled from 'styled';
import Localizable from 'lib/intl/localizable';

import { VendorLink } from 'four-nets/user/vendor-link';
import { displayedName } from 'four-nets/user/utils';
import { DeletedContent } from 'four-nets/common/deleted-content';
import VendorBadge from 'four-nets/ui-v2/badges/vendor-badge/vendor-badge';

import defaultStyles from './comment-header-view.scss';

export class CommentHeaderViewModel {
    comment: Comment;
    vendorLink: ?VendorLink;

    constructor(options) {
        const { comment } = options;

        this.comment = comment;
    }
}

@Localizable()
@Styled(defaultStyles)
@withRouter
@observer
class CommentHeaderView extends React.Component {
    onUsernameClick = username => () => {
        const { vendor } = this.props.commentHeaderViewModel.comment.user;
        this.props.history.push({
            pathname: vendor ? `/catalog/vendor/${username}/` : `/blog/${username}/`,
        });
    };

    render() {
        const { commentHeaderViewModel, styles } = this.props;
        const { comment } = commentHeaderViewModel;
        const { user, displayedContent } = comment;

        return (
            <div className={styles.commentHeader}>
                <div className={styles.userWrapper}>
                    <div className={styles.linkWrapper}>
                        <button
                            onClick={this.onUsernameClick(user.username)}
                            className={classnames(styles.user, {
                                [styles.deleted]: displayedContent instanceof DeletedContent,
                            })}
                        >
                            {user.vendor && user.vendor.name ? user.vendor.name : displayedName(user)}
                        </button>
                        {user.vendor ? <VendorBadge style={{ badge: styles.badge }} /> : null}
                        {user.vendor &&
                        user.vendor.web &&
                        user.vendor.paidTillDate >= new Date().setHours(0, 0, 0, 0) ? (
                            <>
                                &nbsp;|&nbsp;
                                <a
                                    className={styles.vendorLink}
                                    target='_blank'
                                    rel='noopener'
                                    href={
                                        user.vendor.web.match(/https?:\/\//)
                                            ? user.vendor.web
                                            : `http://${user.vendor.web}`
                                    }
                                >
                                    {user.vendor.web.replace(/^https?:\/\//, '')}
                                </a>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default CommentHeaderView;
